// frontend/src/components/chat/ConversationList.js
// Lista de conversaciones

import React, { useState } from 'react';
import './ConversationList.css';

const ConversationList = ({ conversations, activeId, onSelect, loading, currentUserId }) => {
    const [searchQuery, setSearchQuery] = useState('');

    // Filtrar conversaciones por busqueda
    const filteredConversations = conversations.filter(conv => {
        const name = conv.display_name || conv.name || '';
        return name.toLowerCase().includes(searchQuery.toLowerCase());
    });

    // Formatear tiempo relativo
    const formatTime = (dateString) => {
        if (!dateString) return '';

        const date = new Date(dateString);
        const now = new Date();
        const diff = now - date;
        const minutes = Math.floor(diff / 60000);
        const hours = Math.floor(diff / 3600000);
        const days = Math.floor(diff / 86400000);

        if (minutes < 1) return 'Ahora';
        if (minutes < 60) return `${minutes}m`;
        if (hours < 24) return `${hours}h`;
        if (days < 7) return `${days}d`;

        return date.toLocaleDateString('es-EC', { day: '2-digit', month: '2-digit' });
    };

    // Obtener inicial para avatar
    const getInitial = (name) => {
        return name ? name.charAt(0).toUpperCase() : '?';
    };

    if (loading) {
        return (
            <div className="urbanq-conversation-list">
                <div className="urbanq-conversation-search">
                    <input type="text" placeholder="Buscar conversacion..." disabled />
                </div>
                <div className="urbanq-conversation-loading">
                    {[1, 2, 3, 4].map(i => (
                        <div key={i} className="urbanq-conversation-skeleton">
                            <div className="urbanq-skeleton-avatar"></div>
                            <div className="urbanq-skeleton-content">
                                <div className="urbanq-skeleton-line short"></div>
                                <div className="urbanq-skeleton-line"></div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    return (
        <div className="urbanq-conversation-list">
            {/* Barra de busqueda */}
            <div className="urbanq-conversation-search">
                <svg viewBox="0 0 24 24" fill="currentColor" className="urbanq-search-icon">
                    <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
                </svg>
                <input
                    type="text"
                    placeholder="Buscar conversacion..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />
            </div>

            {/* Lista */}
            <div className="urbanq-conversation-items">
                {filteredConversations.length === 0 ? (
                    <div className="urbanq-conversation-empty">
                        <p>{searchQuery ? 'No se encontraron conversaciones' : 'No tienes conversaciones aun'}</p>
                    </div>
                ) : (
                    filteredConversations.map(conv => (
                        <div
                            key={conv.id}
                            className={`urbanq-conversation-item ${activeId === conv.id ? 'active' : ''} ${conv.unread_count > 0 ? 'unread' : ''}`}
                            onClick={() => onSelect(conv)}
                        >
                            {/* Avatar */}
                            <div className="urbanq-conversation-avatar">
                                {conv.display_avatar ? (
                                    <img src={conv.display_avatar} alt="" />
                                ) : (
                                    <span className={`urbanq-avatar-initial ${conv.type === 'group' ? 'group' : ''}`}>
                                        {conv.type === 'group' ? '👥' : getInitial(conv.display_name)}
                                    </span>
                                )}
                                {conv.type === 'individual' && conv.is_online && (
                                    <span className="urbanq-online-indicator"></span>
                                )}
                            </div>

                            {/* Contenido */}
                            <div className="urbanq-conversation-content">
                                <div className="urbanq-conversation-header">
                                    <span className="urbanq-conversation-name">
                                        {conv.display_name || conv.name || 'Sin nombre'}
                                    </span>
                                    <span className="urbanq-conversation-time">
                                        {formatTime(conv.last_message_at || conv.updated_at)}
                                    </span>
                                </div>
                                <div className="urbanq-conversation-preview">
                                    <span className="urbanq-conversation-message">
                                        {conv.last_message || 'Sin mensajes'}
                                    </span>
                                    {conv.unread_count > 0 && (
                                        <span className="urbanq-conversation-badge">
                                            {conv.unread_count > 99 ? '99+' : conv.unread_count}
                                        </span>
                                    )}
                                </div>
                            </div>

                            {/* Silenciado */}
                            {conv.is_muted && (
                                <span className="urbanq-conversation-muted" title="Silenciado">
                                    🔇
                                </span>
                            )}
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default ConversationList;
